<template>
  <!-- 确认框组件 -->
  <div 
    id="confirm-modal"
    class="fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300"
    :class="{ 'opacity-0 pointer-events-none': !isVisible }"
  >
    <div 
      class="absolute inset-0 bg-dark/80 backdrop-blur-sm"
      id="confirm-backdrop"
      @click="handleCancel"
    ></div>
    <div 
      class="relative bg-dark-800 rounded-2xl w-full max-w-md mx-4 overflow-hidden gradient-border transition-transform duration-300"
      id="confirm-content"
      :class="{ 'scale-100': isVisible, 'scale-95': !isVisible }"
    >
      <div class="p-6 md:p-8">
        <div class="text-center mb-6">
          <div class="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center bg-warning/20">
            <i class="fa fa-exclamation-triangle text-warning text-5xl"></i>
          </div>
          <h3 class="text-xl font-bold mb-2" id="confirm-title">{{ title }}</h3>
          <p class="text-dark-600" id="confirm-message">{{ message }}</p>
        </div>
        <div class="flex space-x-3">
          <button 
          id="confirm-cancel"
          class="flex-1 py-3 px-4 bg-dark border border-dark-700 rounded-lg font-medium hover:bg-dark-700 transition-all duration-300 text-white" 
          @click="handleCancel"
        >
          取消
        </button>
          <button 
            id="confirm-ok"
            class="flex-1 py-3 px-4 bg-gradient-to-r from-primary to-accent rounded-lg font-medium hover:opacity-90 transition-all duration-300"
            @click="handleConfirm"
          >
            确认
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      isVisible: false,
      title: '确认操作',
      message: '您确定要执行此操作吗？',
      resolveCallback: null // 用于保存Promise的resolve方法
    }
  },
  mounted() {
    // 监听ESC键关闭确认框
    document.addEventListener('keydown', this.handleEscKey)
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('keydown', this.handleEscKey)
  },
  methods: {
    // 显示确认框，返回Promise
    show(options = {}) {
      return new Promise(resolve => {
        // 保存resolve回调
        this.resolveCallback = resolve
        // 设置内容
        this.title = options.title || '确认操作'
        this.message = options.message || '您确定要执行此操作吗？'
        // 显示确认框
        this.isVisible = true
        document.body.style.overflow = 'hidden'
      })
    },

    // 处理确认
    handleConfirm() {
  // 先执行回调，再隐藏
      this.resolveCallback(true)
      this.hide()
    },

    // 处理取消
    handleCancel() {
      // 先执行回调，再隐藏
      this.resolveCallback(false)
      this.hide()
    },

    // 隐藏确认框
    hide() {
      this.isVisible = false
      document.body.style.overflow = ''
      this.resolveCallback = null
    },

    // 处理ESC键
    handleEscKey(e) {
      if (e.key === 'Escape' && this.isVisible) {
        this.handleCancel()
      }
    }
  }
}
</script>